import { useState, useCallback } from "react";
import { ProductService } from "../../../services/ProductService.js";

const productService = new ProductService();

const useProductos = (baseUrl, empresa, nombreEmpresa) => {
  const [productos, setProductos] = useState([]);
  const [loadingInicial, setLoadingInicial] = useState(false);

  const fetchData = useCallback(async () => {
    if (!empresa) return;
    setLoadingInicial(true);
    try {
      const productosData = await productService.getProductosByEmpresa(baseUrl, nombreEmpresa);
      setProductos(productosData);
    } catch (error) {
      console.error("Error fetching productos:", error);
    } finally {
      setLoadingInicial(false);
    }
  }, [baseUrl, empresa, nombreEmpresa]);

  return { productos, setProductos, loadingInicial, fetchData };
};

export default useProductos;
